import React, { createContext, useContext, useMemo, useState } from "react";
import { Modal } from "antd";

export const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    open: false,
    title: "",
    component: null,
    width: 520,
  });

  const showModal = ({ title, component, width }) => {
    setModalState({
      open: true,
      title,
      component,
      width: width || 520,
    });
  };

  const hideModal = () => {
    setModalState(prev => ({
      ...prev,
      open: false,
    }));
  };

  const value = useMemo(() => ({
  showModal,
  hideModal
}), []);


  return (
    <ModalContext.Provider value={value}>
      {children}

      <Modal
        open={modalState.open}
        onCancel={hideModal}
        footer={null}
        header={null}
        title={modalState.title}
        width={modalState.width}
        bodyStyle={{ padding: 12 }}
        styles={{
          header: { padding: "10px 16px" },
        }}
        destroyOnClose
      >
        {modalState.component}
      </Modal>
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);